import React from "react";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import ModalButtons from "../ModalButtons/ModalButtons";
import Tabs from "../Tabs/Tabs";
import RateBuilderTabContent from "./RateBuilderTabContent";
import RateBuilderErrors from "./RateBuilderErrors";
import ReactPortalsRoot from "../ReactPortalsRoot/ReactPortalsRoot";
import ModalWarning from "../ModalWarning/ModalWarning";
import GeneralWarningModal from "../ChartBuilder/GeneralWarningModal";
import DateHelper from "../DateHelper/DateHelper";
import { format, parseISO } from "date-fns";

class RateBuilder extends React.Component {
  constructor(props) {
    super(props);
    var room_types;
    this.props.room_types && this.props.room_types
      ? (room_types = this.props.room_types.map((type) => type.id))
      : (room_types = []);

    var seasonal_rates
    this.props.seasonal_rates && this.props.seasonal_rates.length
      ? seasonal_rates = this.props.seasonal_rates.map(seasonal_rate => seasonal_rate.season_id)
      : seasonal_rates = []

    this.state = {
      active_tab: this.props.active_tab || "general",
      tabs: typeof this.props.tabs !== "undefined" ? this.props.tabs : true,
      loading: false,
      dateFormat: this.props.date_format,
      numberFormat:
        "0" +
        ($("#delimiter").val() || ",") +
        "0" +
        ($("#separator").val() || ".") +
        "00",

      all_room_types: this.props.all_room_types || [],
      all_products: this.props.all_products || [],
      all_fees: this.props.all_fees || [],
      all_taxes: this.props.all_taxes || [],
      all_seasons: this.props.all_seasons,
      order_form: this.props.order_form || "",
      survey_form: this.props.survey_form || "",
      all_guest_types: this.props.all_guest_types || [],
      errors: this.props.errors || [],
      id: this.props.id,
      code: this.props.code || "",
      name: this.props.name || "",
      status: this.props.status,
      rate_type: this.props.rate_type || "transient",
      is_hidden: this.props.is_hidden || false,
      amount:
        this.props.amount || this.props.amount === 0 ? this.props.amount : "",
      percentage:
        this.props.percentage || this.props.percentage === 0
          ? this.props.percentage
          : "",
      check_in_time: this.props.check_in_time
        ? DateHelper.parseDate(this.props.check_in_time)
        : "",
      check_out_time: this.props.check_out_time
        ? DateHelper.parseDate(this.props.check_out_time)
        : "",
      duplicate: this.props.duplicate || null,
      property: this.props.property,
      short_description: this.props.short_description || "",
      long_description: this.props.long_description || "",
      minimum_stay: this.props.minimum_stay !== undefined && this.props.minimum_stay !== null ? this.props.minimum_stay : "",
      maximum_stay: this.props.maximum_stay !== undefined && this.props.maximum_stay !== null ? this.props.maximum_stay : "",
      minimum_lead: this.props.minimum_lead !== undefined && this.props.minimum_lead !== null ? this.props.minimum_lead : "",
      maximum_lead: this.props.maximum_lead !== undefined && this.props.maximum_lead !== null ? this.props.maximum_lead : "",
      start_booking_date: this.props.start_booking_date
        ? parseISO(this.props.start_booking_date)
        : "",
      end_booking_date: this.props.end_booking_date
        ? parseISO(this.props.end_booking_date)
        : "",
      maximum_uses: this.props.maximum_uses !== undefined && this.props.maximum_uses !== null ? this.props.maximum_uses : "",
      updated_at: this.props.updated_at,

      billing_policy: this.props.billing_policy,
      guest_types: this.props.guest_types || [],
      rate_guest_types: this.props.rate_guest_types || [],
      rate_products: this.props.rate_products || [],
      products: this.props.products || [],
      fees: this.props.associated_fees,
      taxes: this.props.associated_taxes,
      room_types: room_types,
      seasonal_rates: seasonal_rates,
      channel_rate_room_types: this.props.channel_rate_room_types,
      displayChannelWarning: false,
      default_number_of_nights: this.props.default_number_of_nights || 0,
      new_record: this.props.new_record || false,
    };

    this.onChange = this.onChange.bind(this);
    this.onChangeProducts = this.onChangeProducts.bind(this);
    this.onAddProduct = this.onAddProduct.bind(this);
    this.onRemoveProduct = this.onRemoveProduct.bind(this);
    this.onAddGuestType = this.onAddGuestType.bind(this);
    this.onRemoveGuestType = this.onRemoveGuestType.bind(this);
    this.onChangeFees = this.onChangeFees.bind(this);
    this.onChangeTaxes = this.onChangeTaxes.bind(this);
    this.onChangeRoomTypes = this.onChangeRoomTypes.bind(this);
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
    this.onChangeProperty = this.onChangeProperty.bind(this);
    this.onChangeSeasonalRates = this.onChangeSeasonalRates.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  componentDidUpdate() {
    if (typeof initTypeahead == "function" && this.refs.root) {
      window.initTypeahead($(this.refs.root).find("[data-model][data-column]"));
    }
  }

  render() {
    return (
      <div className="rate-builder" ref="root">
        <Tabs
          tabs={this.tabs()}
          displayErrorMessage={
            RateBuilderErrors.general(this.state.errors).length ||
              RateBuilderErrors.billing_policy(this.state.errors).length ||
              RateBuilderErrors.products(this.state.errors).length ||
              RateBuilderErrors.seasonal_rates(this.state.errors).length ||
              RateBuilderErrors.room_types(this.state.errors).length ||
              RateBuilderErrors.guest_types(this.state.errors).length
              ? true
              : false
          }
        />
        <div className="panel panel-form">
          {this.props.nested ? null : (
            <ModalButtons
              loading={this.state.loading}
              buttons={this.setButtons()}
            />
          )}
          <RateBuilderTabContent
            {...this.state}
            date_format={this.props.date_format}
            time_format={this.props.time_format}
            read_only={this.props.read_only}
            onChange={this.onChange}
            onChangeProducts={this.onChangeProducts}
            onChangeFees={this.onChangeFees}
            onChangeTaxes={this.onChangeTaxes}
            onChangeProperty={this.onChangeProperty}
            onAddProduct={this.onAddProduct}
            onRemoveProduct={this.onRemoveProduct}
            onChangeRoomTypes={this.onChangeRoomTypes}
            onChangeSeasonalRates={this.onChangeSeasonalRates}
            onChangeArrivalForm={this.onChangeArrivalForm}
            onChangeDepartureForm={this.onChangeDepartureForm}
            onAddGuestType={this.onAddGuestType}
            onRemoveGuestType={this.onRemoveGuestType}
          />
          <LoadingSpinner show={this.state.loading} />
        </div>
        {this.state.displayChannelWarning ? (
          <ReactPortalsRoot
            children={[
              <ModalWarning
                key="body"
                title={I18n.t("warning")}
                body={
                  <GeneralWarningModal
                    translatedString={I18n.t("rate_channel_warning")}
                  />
                }
                CancelSubmit
                onSubmit={this.onSave}
                onCancel={() => this.setState({ displayChannelWarning: false })}
              />,
            ]}
            wrapperClassNames="ModalWarningWrapper"
          />
        ) : null}
      </div>
    );
  }

  setButtons = () => {
    if (this.props.buttons) {
      return this.props.buttons;
    } else {
      return [
        {
          name: I18n.t("cancel"),
          html_attributes: ['data-dismiss="modal"'],
        },
        {
          name: I18n.t("submit"),
          button_classes: ["primary"],
          onClick: (e) => {
            e.stopPropagation();
            e.preventDefault();

            this.props.status === "disabled" && this.state.status === "enabled"
              ? this.setState({ displayChannelWarning: true })
              : this.onSave();
          },
        },
      ];
    }
  };

  renderFieldErrors(field) {
    if (this.state.errors && this.state.errors[field]) {
      var idx = 0;
      var errors = this.state.errors[field].map((error) => {
        idx = idx + 1;
        return (
          <li key={idx}>
            <b>&#x2022;</b> {error}
          </li>
        );
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldClasses(field) {
    var classname = "form-control";
    if (
      this.state.errors &&
      Object.keys(this.state.errors).length &&
      this.state.errors[field]
    ) {
      classname = classname + " has-errors";
    }
    return classname;
  }

  tabs() {
    return this.props.read_only && this.state.revert != true
      ? [
        {
          tabName: I18n.t("general"),
          targetName: "general",
          classes: this.state.active_tab === "general" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: RateBuilderErrors.general(this.state.errors).length,
        },
        {
          tabName: I18n.t("billing_policy"),
          targetName: "billing_policy",
          classes:
            this.state.active_tab === "billing_policy" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: RateBuilderErrors.billing_policy(this.state.errors)
            .length,
        },
        {
          tabName: I18n.t("products"),
          targetName: "products",
          classes: this.state.active_tab === "products" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: RateBuilderErrors.products(this.state.errors).length,
        },
        {
          tabName: I18n.t("room_types"),
          targetName: "room_types",
          classes: this.state.active_tab === "room_types" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: RateBuilderErrors.room_types(this.state.errors).length,
        },
        {
          tabName: I18n.t("seasons"),
          targetName: "seasonal_rates",
          classes: this.state.active_tab === "seasonal_rates" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
          // tabErrorCount: RateBuilderErrors.seasons(this.state.errors).length,

        },
        {
          tabName: I18n.t("taxes_and_fees"),
          targetName: "taxes_and_fees",
          classes:
            this.state.active_tab === "taxes_and_fees" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: RateBuilderErrors.taxes_and_fees(this.state.errors).length,
        },
        {
          tabName: I18n.t("channels"),
          targetName: "channels",
          classes: this.state.active_tab === "channels" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t("history"),
          targetName: "history",
          classes: this.state.active_tab === "history" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
        },
      ]
      : [
        {
          tabName: I18n.t("general"),
          targetName: "general",
          classes: this.state.active_tab === "general" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: RateBuilderErrors.general(this.state.errors).length,
        },
        {
          tabName: I18n.t("billing_policy"),
          targetName: "billing_policy",
          classes:
            this.state.active_tab === "billing_policy" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: RateBuilderErrors.billing_policy(this.state.errors)
            .length,
        },
        {
          tabName: I18n.t("products"),
          targetName: "products",
          classes: this.state.active_tab === "products" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: RateBuilderErrors.products(this.state.errors).length,
        },
        {
          tabName: I18n.t("room_types"),
          targetName: "room_types",
          classes: this.state.active_tab === "room_types" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: RateBuilderErrors.room_types(
            this.state.errors
          ).length,
        },
        {
          tabName: I18n.t("seasons"),
          targetName: "seasonal_rates",
          classes: this.state.active_tab === "seasonal_rates" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
          // tabErrorCount: RateBuilderErrors.seasons(this.state.errors).length,

        },
        {
          tabName: I18n.t("taxes_and_fees"),
          targetName: "taxes_and_fees",
          classes: this.state.active_tab === "taxes_and_fees" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: RateBuilderErrors.taxes_and_fees(this.state.errors).length,
        },
        {
          tabName: I18n.t("channels"),
          targetName: "channels",
          classes: this.state.active_tab === "channels" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
        },
      ];
  }

  /******************
   * Change handlers *
   *******************/

  onChange(event) {
    if (event && event.target) {
      var state = { ...this.state };

      if (event.target.type === "checkbox") {
        state[event.target.name] = event.target.checked;
      } else {
        state[event.target.name] = event.target.value;
      }

      if (event.target.name === "amount") {
        if (
          (event.target.value && event.target.value !== "") ||
          event.target.value == 0
        ) {
          state["percentage"] = "";
        }
      } else if (event.target.name === "percentage") {
        if (
          (event.target.value && event.target.value !== "") ||
          event.target.value == 0
        ) {
          state["amount"] = "";
        }
      }

      this.setState(state);
    }
  }

  onChangeProducts(selected_products) {
    this.setState({ products: selected_products });
  }

  onChangeRoomTypes(selected_room_types) {
    this.setState({ room_types: selected_room_types });
  }

  onChangeSeasonalRates(seasonal_rates) {
    this.setState({ seasonal_rates: seasonal_rates });
  }

  onChangeFees(selected_fees) {
    this.setState({
      fees: selected_fees,
    });
  }

  onChangeTaxes(selected_taxes) {
    this.setState({
      taxes: selected_taxes,
    });
  }

  onAddProduct(product) {
    var products = this.state.products;
    products.push(product);
    var rate_products = this.state.rate_products;
    var rate_product = {
      rate_id: this.props.id,
      product_id: product.id,
      quantity: 1,
    };
    rate_products.push(rate_product);
    this.setState({ products: products, rate_products: rate_products });
  }

  onRemoveProduct(product_id) {
    var products = this.state.products.slice(0);
    var rate_products = this.state.rate_products.slice(0);
    var rp_idx = this.getRateProductIndexById(product_id);
    var idx = this.getProductIndexById(product_id);

    if (idx >= 0) {
      products.splice(idx, 1);
    }

    if (rp_idx >= 0) {
      rate_products[rp_idx]._destroy = true
      // rate_products.splice(rp_idx, 1);
    }

    this.setState({ products: products, rate_products: rate_products });
  }

  getRateProductIndexById(id) {
    for (var i = 0, ilen = this.state.rate_products.length; i < ilen; i++) {
      if (this.state.rate_products[i].product_id == id) {
        return i;
      }
    }
  }

  getProductIndexById(id) {
    for (var i = 0, ilen = this.state.products.length; i < ilen; i++) {
      if (this.state.products[i].id == id) {
        return i;
      }
    }
  }

  onAddGuestType(guest_type) {
    var guest_types = this.state.guest_types;
    guest_types.push(guest_type);
    var rate_guest_types = this.state.rate_guest_types;
    var rate_guest_type = {
      rate_id: this.props.id,
      guest_type_id: guest_type.id,
    };
    rate_guest_types.push(rate_guest_type);
    this.setState({
      guest_types: guest_types,
      rate_guest_types: rate_guest_types,
    });
  }

  onRemoveGuestType(guest_type_id) {
    var guest_types = this.state.guest_types.slice(0);
    var rate_guest_types = this.state.rate_guest_types.slice(0);
    var rgt_idx = this.getRateGuestTypeIndexById(guest_type_id);
    var idx = this.getGuestTypeIndexById(guest_type_id);

    if (idx >= 0) {
      guest_types.splice(idx, 1);
    }

    if (rgt_idx >= 0) {
      rate_guest_types.splice(rgt_idx, 1);
    }

    this.setState({
      guest_types: guest_types,
      rate_guest_types: rate_guest_types,
    });
  }

  getRateGuestTypeIndexById(id) {
    for (var i = 0, ilen = this.state.rate_guest_types.length; i < ilen; i++) {
      if (this.state.rate_guest_types[i].guest_type_id == id) {
        return i;
      }
    }
  }

  getGuestTypeIndexById(id) {
    for (var i = 0, ilen = this.state.guest_types.length; i < ilen; i++) {
      if (this.state.guest_types[i].id == id) {
        return i;
      }
    }
  }

  onChangeActiveTab(active_tab) {
    this.setState({ active_tab: active_tab });
  }

  onChangeProperty(property) {
    this.setState({ property: property });
  }

  onSave() {
    this.setState({ loading: true });
    var params = this.prepParams();
    $.ajax({
      type: this.props.new_record ? "POST" : "PATCH",
      url: this.props.form_action,
      data: params,
    })
      .done((data) => {

        window.parent.$(window.parent).trigger("rateSaved", data);
        this.setState({ loading: false });
        if (parent && parent.refresh_data) {
          if (this.props.new_record == true) {
            parent.refresh_data(I18n.t("rate_created_successfully"));
          } else {
            parent.refresh_data(I18n.t("rate_saved_successfully"));
          }
        }

        if (parent && parent.hide_modal) {
          parent.hide_modal();
        }
      })
      .catch((data) => {
        if (data && data.responseJSON) {
          this.setState({
            errors: data.responseJSON,
            loading: false,
            displayChannelWarning: false,
          });
          $(".modal-body").scrollTop(0);
        }
      });
  }

  /*******************
   * Helper functions *
   ********************/

  capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  cleanArray(actual) {
    var newArray = new Array();
    for (var i = 0; i < actual.length; i++) {
      if (actual[i]) {
        newArray.push(actual[i]);
      }
    }
    return newArray;
  }

  generateId() {
    var text = "";
    var possible = "0123456789";

    for (var i = 0; i < 9; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return "-" + text;
  }

  prepParams() {
    var params = {
      rate: {
        amount: this.state.amount,
        percentage: this.state.percentage,
        exact_start_date: this.state.exact_start_date,
        exact_end_date: this.state.exact_end_date,
        repeats: this.state.repeats,
        rate_type: this.state.rate_type,
        is_hidden: this.state.is_hidden,
        season_type: this.state.season_type,
        holiday_region: this.state.holiday_region,
        holiday_name: this.state.holiday_name,
        holiday_days_after: this.state.holiday_days_after,
        holiday_days_before: this.state.holiday_days_before,
        day_number_start: this.state.day_number_start,
        week_number_start: this.state.week_number_start,
        day_number_end: this.state.day_number_end,
        week_number_end: this.state.week_number_end,
        check_in_time: this.state.check_in_time ? format(
          this.state.check_in_time,
          DateHelper.rubyToDateFNS(this.props.time_format)
        ) : null,
        check_out_time: this.state.check_out_time ? format(
          this.state.check_out_time,
          DateHelper.rubyToDateFNS(this.props.time_format)
        ) : null,
        code: this.state.code,
        name: this.state.name,
        short_description: this.state.short_description,
        long_description: this.state.long_description,
        minimum_stay: this.state.minimum_stay,
        maximum_stay: this.state.maximum_stay,
        minimum_lead: this.state.minimum_lead,
        maximum_lead: this.state.maximum_lead,
        start_booking_date: this.state.start_booking_date,
        end_booking_date: this.state.end_booking_date,
        maximum_uses: this.state.maximum_uses,
        status: this.state.status,
        updated_at: this.state.updated_at,
        season_ids: this.state.seasonal_rates,
        rate_products_attributes: this.state.rate_products,
        room_type_ids: this.state.room_types,
        billing_policy_id: this.state.billing_policy ? this.state.billing_policy.id : null,
      },
    };



    if (this.state.order_form != "") {
      params["order_form"] = this.state.order_form.id;
    }
    if (this.state.survey_form != "") {
      params["survey_form"] = this.state.survey_form.id;
    }

    return params;
  }
}

export default RateBuilder;
